import request from "@/utils/httpRequest.js"

/**
 */
 export function fetchTesting(params) {
  return request({
    url: 'testing/base',
    method: 'get',
    params
  })
}

export function detail(params) {
  return request({
    url: 'testing/base/detail',
    method: 'get',
    params
  })
}